<template>
  <div class="addMaterialy">
    <el-dialog class="text-center" title="添加材料" :visible.sync="addMaterialyVisible" width="1250px" :show-close="true" append-to-body v-if="addMaterialyVisible">
      <div class="content text-left flex bg-f3f4f7 flex-column ptb-10 plr-20">
        <div class="flex-1 h-0 mb-10">
          <erp-table ref="erpTable" :table-data="tableData" :loading="loading" :column-data="columnData" @on-add="onAdd"></erp-table>
        </div>
        <Pagination :pageSize="pageSize" v-model="pageNo" :pageTotal="pageTotal" :total="total" @on-jump="jump"></Pagination>
          <!--<div class="flex mb-10">-->
            <!--<div class="flex ml-10">-->
              <!--<div class="flex align-center bg-ff h-30 border-e2 border-ra mr-10 search">-->
                <!--<img src="/static/images/sousuo.png" class="icon-14 ml-10 mr-5" alt="">-->
                <!--<el-input type="text" placeholder="材料/品牌/规格型号/编码" v-model="keywords" clearable></el-input>-->
              <!--</div>-->
              <!--<button class="btn-30-bg-46b8b0" @click="searchBtn">搜索</button>-->
            <!--</div>-->
          <!--</div>-->
      </div>
    </el-dialog>
  </div>
</template>
<script>
import ErpTable from '../../../components/ErpTable'
import CateMenu from '../../../components/CateMenu'
import MoveHorizon from '../../../components/MoveHorizon'
import Pagination from '@/components/Pagination'
export default {
  name: 'sourceMaterialy',
  components: {ErpTable, CateMenu, MoveHorizon, Pagination},
  props: ['orderDefine', 'receiptStatus', 'customerId'],
  data () {
    return {
      addMaterialyVisible: false,
      loading: true,
      tableData: [],
      columnData: [{
        field: 'operate',
        title: '操作',
        width: '70',
        isDefine: true,
        child: [{
          className: 'btn-16-color-46b8b0 btn-hover-46b8b0',
          title: '添加',
          methodName: 'on-add',
          type: 'btn'
        }]
      }, {
        field: 'specialItem',
        title: '特项',
        minWidth: '120'
      }, {
        field: 'roomName',
        title: '房间位置',
        minWidth: '120'
      }, {
        field: 'name',
        title: '材料名称',
        minWidth: '150'
      }, {
        field: 'subitem',
        title: '项目备注',
        minWidth: '150'
      }, {
        field: 'unit',
        title: '单位',
        width: '100'
      }, {
        field: 'quantity',
        title: '数量',
        minWidth: '120'
      }, {
        field: 'availableQuantity',
        title: '剩余可开数量',
        minWidth: '100'
      }, {
        field: 'actualQuantity',
        title: '实际领用量',
        minWidth: '150'
      }, {
        field: 'costPrice',
        title: '成本单价',
        width: '100'
      }, {
        field: 'settlementCostSum',
        title: '成本合价',
        minWidth: '120'
      }, {
        field: 'clientPrice',
        title: '客户单价',
        minWidth: '100'
      }, {
        field: 'settlementClientSum',
        title: '客户合价',
        minWidth: '100'
      }],
      currentMenu: null,
      page: 1,
      limit: 25,
      pageSize: 10, // 总页数
      pageNo: 1, // 当前页数
      pageTotal: 25, // 当前页条数
      total: 100 // 总条数
    }
  },
  created () {},
  mounted () {
  },
  methods: {
    getData () {
      this.axios.post(`budgetContent/requirementMaterialList`, {
        customerId: this.customerId,
        page: this.page,
        limit: this.limit
      }).then(res => {
        if (res.data.success) {
          if (res.data.data.list.length === 0) {
            this.$alert('没有填核算量或未锁定', '提示', {
              confirmButtonText: '确定'
            })
          }
          this.tableData = res.data.data.list
          this.pageSize = res.data.data.pages
          this.pageNo = this.page
          this.pageTotal = res.data.data.size
          this.total = res.data.data.total
          this.loading = false
        }
      })
    },
    searchBtn () {
      this.page = 1
      this.getData()
    },
    onAdd (row) {
      let arr = ['totalCost']
      if (this.orderDefine.costPriceAdd !== 1) {
        arr.push(this.orderDefine.costPriceField)
      }
      if (row.isModified === -1) {
        let unEditableArr = ['materialCode', 'materialName', 'materialMode', 'materialUnit']
        arr = arr.concat(unEditableArr)
      }
      console.log(row)
      let item = {
        ...row,
        name: row.name,
        unEditable: arr.join(','),
        materialId: row.materialId,
        materialName: row.name,
        materialCode: row.code,
        materialStandard: row.standard,
        materialMode: row.model,
        materialUnit: row.unit || row.salesUnit,
        specialItem: row.specialItem,
        quantity: row.availableQuantity,
        totalCost: row.costPrice,
        customerPrice: row.clientPrice,
        costPrice: row.costPrice,
        projectPrice: row.projectPrice,
        remark: row.subitem,
        requirementMaterialId: row.materialId,
        isModified: row.isModified,
        businessId: row.businessId,
        businessName: row.businessName,
        curBalanceQuantity: row.curBalanceQuantity
      }
      let addFlag = true
      if (this.$parent.$parent.addMaterialList.length > 0) {
        for (let k of this.$parent.$parent.addMaterialList) {
          if (k.materialId === item.materialId) {
            addFlag = false
            break
          }
        }
      }
      if (addFlag) {
        for (let i of this.$parent.$parent.tableData) {
          if (i.materialId === item.materialId) {
            addFlag = false
            for (let j of this.$parent.$parent.deleteMaterialList) {
              if (j.materialId === item.materialId) {
                addFlag = true
                break
              }
            }
            break
          }
        }
      }
      if (addFlag) {
        if (this.receiptStatus === 0) { // 0新增 1详情
          this.$parent.$parent.tableData.push(item)
          if (item.businessId !== null) {
            this.$parent.$parent.businessId = item.businessId
            this.$parent.$parent.businessName = item.businessName
          }
        } else {
          this.$parent.$parent.$refs.erpTable.insertAt(item, -1)
          this.$parent.$parent.getAddData()
        }
        this.$message({
          message: '材料添加成功',
          type: 'success'
        })
      } else {
        this.$message({
          message: '材料已存在',
          type: 'warning'
        })
      }
    },
    jump (page) { // 分页
      this.page = page.pageNo
      this.limit = page.pageTotal
      this.getData()
    }
  },
  watch: {
    keywords (val) {
      if (val === '') {
        this.getData()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .content{
    height: 520px;
  }
  .addMaterialy /deep/ .el-dialog{
    height: 80%;
    display: flex;
    flex-direction: column;
  }
  .addMaterialy /deep/ .el-dialog__body{
    flex: 1;
    min-height: 0;
    height: 0;
  }
  .button{
    border: solid 1px #e2e2e2;
    border-radius: 4px;
    cursor: pointer;
  }
  .content .title{
    height: 30px;
    padding-left: 10px;
    border-radius: 4px;
  }
  .search {
    overflow: hidden;
  }
  .search /deep/.el-input__inner{
    padding-left: 0;
    border: none;
    outline: none;
  }
</style>



// WEBPACK FOOTER //
// src/pages/order/components/sourceMaterialy.vue